import { useCallback, useState } from 'react';
import { config2Str } from 'z3k-parser/parser/config-convertor/parser';
import { dummyConfig } from 'z3k-parser/lib';
import * as deepExtend from 'deep-extend';
import * as iconv from 'iconv-lite';
import { upload_z3k_config_from_file, } from 'z3k-settings/redux/actions';
import { useAction } from 'shared/hooks/redux/hooks';
import * as lodash from 'lodash';
export const useNewConfigBeforeComparison = () => {
    const [newSetter, setNewSetter] = useState([]);
    const onUploadSettings = useAction(upload_z3k_config_from_file);
    const onCheckNewConfig = useCallback((event, data) => {
        if (Array.isArray(data)) {
            setNewSetter([]);
            if (event.target.checked) {
                const newData = lodash.flatten(data.map((i) => {
                    return Object.keys(i.el.settings).find((key) => key === 'heating_zones') && !i.flag
                        ? i.el
                            .settings.heating_zones.map((item) => {
                            return {
                                ...i,
                                el: {
                                    settings: {
                                        heating_zones: {
                                            ...item.settings,
                                        },
                                        heating_circuit: item.idSensor,
                                    },
                                    id: item.id,
                                },
                                ...(i.flag && { flag: i.flag }),
                            };
                        })
                        : i;
                }));
                setNewSetter(newData);
            }
            else {
                setNewSetter([]);
            }
        }
        else {
            const setterFilter = newSetter.findIndex((el) => el.el.id ===
                data.el.id);
            if (event.target.checked) {
                if (setterFilter !== -1) {
                    setNewSetter((prevState) => prevState.map((el, index) => index === setterFilter
                        ? {
                            ...el,
                            el: {
                                ...el.el,
                                settings: data.el,
                            },
                        }
                        : el));
                }
                else {
                    setNewSetter((prevState) => [...prevState, data]);
                }
            }
            if (!event.target.checked) {
                setNewSetter((prevState) => prevState.filter((item) => item.el.id !==
                    data.el.id));
            }
        }
    }, [newSetter]);
    const newFile = useCallback((content, device_id) => {
        const z3kConfig_str = config2Str(content);
        const z3kConfig_uint8Array = iconv.encode(z3kConfig_str, 'win1251');
        const blob = new Blob([z3kConfig_uint8Array], { type: 'text/plain' });
        const file = new File([blob], 'config.txt', { type: 'text/plain' });
        return onUploadSettings(device_id, file);
    }, []);
    const constructorNewConfig = useCallback((resultCompare, config, device_id) => {
        let newObj = null;
        let newConfig = config;
        //добавляем 'unknown'вручную т к в интерфейсе его не отображаем
        const newUnknown = resultCompare &&
            resultCompare.new.find((elem) => elem.key === 'unknown');
        const setter = newUnknown
            ? [
                ...newSetter,
                {
                    key: 'unknown',
                    el: [
                        {
                            settings: [
                                newUnknown.el[0]
                                    .setter[0].settings,
                            ],
                            id: newUnknown.el[0]
                                .setter[0].id,
                        },
                    ],
                    keyResult: 'new',
                },
            ]
            : newSetter;
        setter.map((data) => {
            const objectOldForKeyInCofig = newConfig[data.key];
            const findObjectOldConfigForId = Array.isArray(objectOldForKeyInCofig) &&
                objectOldForKeyInCofig.find((e) => e.id === data?.idSensor);
            if (objectOldForKeyInCofig) {
                //проверяем что пришло, если [el] - выбран AllValue,обрабатываем
                if (Array.isArray(data.el)) {
                    data.el.map((el) => {
                        //проверяем изменяемые настройки в конфиге лежат ли в массиве
                        if (dummyConfig[data.key]) {
                            if (findObjectOldConfigForId) {
                                let newObjForZone = {};
                                //обрабатываем отдельно heating_zones
                                if (el.settings
                                    .heating_zones) {
                                    let newArrForZone = [];
                                    let oldHeatingZones = {};
                                    el.settings
                                        .heating_zones.map((item) => {
                                        oldHeatingZones = findObjectOldConfigForId.heating_zones.find((i) => i.heating_circuit === item.idSensor);
                                        if (oldHeatingZones &&
                                            item.flag !== 'Удален') {
                                            newArrForZone = [
                                                ...newArrForZone,
                                                deepExtend(oldHeatingZones, item.settings),
                                            ];
                                        }
                                        else {
                                            if (item.flag === 'Добавлен') {
                                                newArrForZone = [
                                                    ...newArrForZone,
                                                    item.settings,
                                                ];
                                            }
                                        }
                                    });
                                    newObjForZone = {
                                        ...el.settings,
                                        heating_zones: newArrForZone,
                                    };
                                }
                                newObj = deepExtend(findObjectOldConfigForId, Object.keys(newObjForZone).length > 0
                                    ? newObjForZone
                                    : el.settings);
                                if (data.flag === 'Удален') {
                                    const removeObj = objectOldForKeyInCofig.filter((elem) => elem.id != data.idSensor);
                                    return (newConfig = {
                                        ...newConfig,
                                        [data.key]: removeObj,
                                    });
                                }
                                else {
                                    return (newConfig = {
                                        ...newConfig,
                                        [data.key]: objectOldForKeyInCofig.map((elem) => elem.id === data.idSensor
                                            ? newObj
                                            : elem),
                                    });
                                }
                            }
                            else {
                                return (newConfig = {
                                    ...newConfig,
                                    [data.key]: [
                                        ...newConfig[data.key],
                                        el.settings,
                                    ],
                                });
                            }
                        }
                        else {
                            return (newConfig = deepExtend(newConfig, {
                                [data.key]: el.settings,
                            }));
                        }
                    });
                }
                else {
                    //если {el} - выбраны don`t AllValue,обрабатываем
                    //проверяем изменяемые настройки в конфиге лежат ли в массиве
                    if (dummyConfig[data.key]) {
                        //обрабатываем отдельно heating_zones
                        if (data.el.settings.heating_zones) {
                            if (data.flag === 'Добавлен') {
                                return (newConfig = {
                                    ...newConfig,
                                    heating_modes: newConfig?.heating_modes
                                        ? [
                                            ...newConfig.heating_modes,
                                            data.el.settings,
                                        ]
                                        : [data.el.settings],
                                });
                            }
                            if (data.flag === 'Удален') {
                                return (newConfig = {
                                    ...newConfig,
                                    heating_modes: newConfig?.heating_modes?.filter((el) => el.id !== data.idSensor),
                                });
                            }
                            if (!data.flag) {
                                return (newConfig = {
                                    ...newConfig,
                                    heating_modes: newConfig?.heating_modes?.map((el) => el.id === data.idSensor
                                        ? {
                                            ...el,
                                            heating_zones: el.heating_zones.map((i) => i.heating_circuit ===
                                                data.el
                                                    .settings.heating_circuit
                                                ? deepExtend(i, data.el
                                                    .settings
                                                    .heating_zones)
                                                : i),
                                        }
                                        : el),
                                });
                            }
                            return newConfig;
                        }
                        if (findObjectOldConfigForId &&
                            !data.el.settings.heating_zones) {
                            if (data.flag === 'Удален') {
                                const removeObj = objectOldForKeyInCofig.filter((elem) => elem.id != data.idSensor);
                                return (newConfig = {
                                    ...newConfig,
                                    [data.key]: removeObj,
                                });
                            }
                            else {
                                newObj = deepExtend(findObjectOldConfigForId, data.el.settings);
                                return (newConfig = {
                                    ...newConfig,
                                    [data.key]: objectOldForKeyInCofig.map((elem) => elem.id === data.idSensor ? newObj : elem),
                                });
                            }
                        }
                        else if (!data.el.settings.heating_zones) {
                            return (newConfig = {
                                ...newConfig,
                                [data.key]: [
                                    ...newConfig[data.key],
                                    data.el.settings,
                                ],
                            });
                        }
                        return newConfig;
                    }
                    else {
                        return (newConfig = deepExtend(newConfig, {
                            [data.key]: data.el
                                .settings,
                        }));
                    }
                }
            }
            else {
                return (newConfig = {
                    ...newConfig,
                    [data.key]: dummyConfig[data.key]
                        ? Array.isArray(data.el)
                            ? data.el.map((elem) => elem.settings)
                            : [data.el.settings]
                        : data.el.settings,
                });
            }
            return newConfig;
        });
        if (newConfig) {
            return newFile(newConfig, device_id);
        }
        return;
    }, [newSetter]);
    return [onCheckNewConfig, newFile, constructorNewConfig, newSetter];
};
